import { useEtherGasEstimate } from '@/hooks/useEstimateGas';

import { Token } from '@/constant';
import application from '@/stores/application';
import { useAddRecentTransaction } from '@rainbow-me/rainbowkit';
import { TransactionResponse } from 'ethers';

interface SendParams {
    contract: any;
    method: string;
    params: any;
    sendParams?: {
        value: string;
    };
    pendingText?: string;
    title?: string;
    summary?: string;
    onSuccess?({ hash, res }: { hash: string; res: any }): Promise<void> | void;
    onError?(e: any): void;
    addTokenToMetamask?: Token;
    showSuccess?: boolean;
    showPending?: boolean;
}

export default function useSend() {
    const getEstimate = useEtherGasEstimate();
    const addRecentTransaction = useAddRecentTransaction();

    async function send({
        contract,
        method,
        params,
        sendParams,
        pendingText,
        summary,
        onSuccess,
        onError,
        addTokenToMetamask,
        showSuccess = true,
        title,
        showPending = true,
    }: SendParams) {
        console.log(contract, method, sendParams, params);
        if (showPending) {
            application.setConfimModal({
                isOpen: true,
                attemptingTxn: true,
                hash: '',
                pendingText: pendingText || '',
                errorMessage: '',
            });
        }

        try {
            return await new Promise(async (resolve) => {
                const res = await getEstimate(
                    contract,
                    method,
                    params,
                    sendParams,
                );

                if (!res.success) {
                    application.setConfimModal({
                        isOpen: true,
                        attemptingTxn: false,
                        hash: '',
                        pendingText: pendingText || '',
                        errorMessage:
                            res.errorMessage ||
                            'Someting wrong, please try again later',
                    });
                    if (onError) {
                        onError(res.errorMessage);
                    }
                    resolve('');
                    return;
                }

                (sendParams
                    ? contract[method](...params, { value: sendParams.value })
                    : contract[method](...params)
                )
                    .then(async (response: TransactionResponse) => {
                        const receipt = await response.wait();
                        if (!receipt?.hash) {
                            application.setConfimModal({
                                isOpen: true,
                                attemptingTxn: false,
                                hash: '',
                                pendingText: '',
                                summery: '',
                                errorMessage: 'Transaction failed!',
                            });

                            resolve('');
                            return;
                        }
                        const hash = receipt.hash;

                        if (showSuccess) {
                            application.setConfimModal({
                                isOpen: true,
                                attemptingTxn: false,
                                hash,
                                pendingText: pendingText || '',
                                summery: summary,
                                errorMessage: '',
                                addTokenToMetamask,
                                title,
                            });
                        } else {
                            application.setConfimModal({
                                isOpen: false,
                                attemptingTxn: false,
                                hash: '',
                                pendingText: '',
                                summery: '',
                            });
                        }

                        if (summary) {
                            await addRecentTransaction({
                                hash,
                                description: summary,
                            });
                        }

                        if (onSuccess) {
                            await onSuccess({
                                hash,
                                res: receipt,
                            });
                        }
                        resolve(receipt);
                    })
                    .catch((e: any) => {
                        console.log('useSend Hooks error');
                        console.error(e.code);
                        application.setConfimModal({
                            isOpen: e.code === 'ACTION_REJECTED' ? false : true,
                            attemptingTxn: false,
                            hash: '',
                            pendingText: pendingText || '',
                            summery: summary || '',
                            errorMessage: e ? (e as any).message : undefined,
                        });
                        if (onError) {
                            onError(e);
                        }
                        resolve('');
                    });
            });
        } catch (e) {
            if (onError) {
                console.error('throw error');
                onError(e);
            }
            console.error(e);
        }
    }

    return send;
}
